import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export interface IEventData {
    fromComponentId: any;
    fromComponentName?: string;
    eventName: string;
    triggerValue: any;
    formId: number;
    datasetId?: number;
}

@Injectable()
export class FormEventService {

    private dataSource = new BehaviorSubject<IEventData>(null);
    private liveSource = new BehaviorSubject<boolean>(null);
    event = this.dataSource.asObservable();
    live = this.liveSource.asObservable();

    constructor() {
    }

    updatedDataSelection(data: IEventData) {
        this.dataSource.next(data);
    }

    updateLiveView(data: boolean) {
        this.liveSource.next(data);
    }

}
